import {ALERT_TYPES, showAlert} from "./alert";
import { handleError } from './handleError.js';
import {api} from "./apiService";

export function initLoginPage() {
    const loginForm = document.getElementById('login-form');
    if (!loginForm) return;

    const usernameInput = document.getElementById('username');
    const passwordInput = document.getElementById('password');
    const rememberInput = document.getElementById('remember_me');
    const loginButton = document.getElementById('login-button');
    const alertId = "login-alert";

    loginForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        loginButton.disabled = true;
        loginButton.innerHTML = 'در حال ورود...';

        try {
            const username = usernameInput.value;
            const password = passwordInput.value;
            const remember_me = rememberInput.checked;

            const data = await api.userLogin(username, password, remember_me);

            showAlert(alertId, ALERT_TYPES.OK, "درسته!", "با موفقیت وارد شدی.")

            const accessToken = data.access_token;
            localStorage.setItem('accessToken', accessToken);
            setTimeout(() => { window.location.href = '/dashboard'; }, 1000);

        } catch (error) {
            handleError(error, alertId);
            resetButtonState();
        }
    });

    function resetButtonState() {
        loginButton.disabled = false;
        loginButton.innerHTML = 'ورود';
    }
}